import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { CustomSVG } from 'components';

interface IProps {
  onClick: () => void;
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[600],
    top: -theme.spacing(),
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.grey[700],
    },
  },
}));

const DownloadButton: FC<IProps> = ({ onClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Tooltip title={t('analytics:requestReport')} placement="left">
      <IconButton className={classes.root} onClick={onClick}>
        <CustomSVG name="download" />
      </IconButton>
    </Tooltip>
  );
};

export default DownloadButton;
